import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Home from './components/Home';
import Register from './components/Register';
import Login from './components/Login';
import TechnicianList from './components/TechnicianList';
import TechnicianProfile from './components/TechnicianProfile';
import ServiceList from './components/ServiceList';
import BookingForm from './components/BookingForm';
import MyBookings from './components/MyBookings';
// import ReviewForm from './components/ReviewForm';
import TechnicianProfileForm from './components/TechnicianProfileForm';
import TechniciansByService from './components/TechniciansByService';
import AuthContext, { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import { NotificationProvider } from './NotificationContext';

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './colors.css';
import './forms.css';
import './auth.css';
import './card-overrides.css';
import './components/ReviewModal.css';

const Navbar = () => {
    const { user, logout } = useContext(AuthContext);

    return (
        <nav className="navbar">
            <div className="navbar-brand" style={{ marginLeft: '20px' }}>
                <Link to="/">
                    <img
                        src="/logo.svg"
                        alt="Local Technician Finder Logo"
                        style={{ height: '40px' }}
                    />
                </Link>
            </div>

            <ul className="navbar-list">
                <li className="navbar-item"><Link to="/" className="navbar-link">Home</Link></li>

                {user && user.role === 'customer' && (
                    <>
                        <li className="navbar-item"><Link to="/technicians" className="navbar-link">Technicians</Link></li>
                        <li className="navbar-item"><Link to="/services" className="navbar-link">Services</Link></li>
                    </>
                )}

                {user ? (
                    <>
                        {user.role === 'technician' && (
                            <li className="navbar-item"><Link to="/profile-form" className="navbar-link">My Profile</Link></li>
                        )}
                        {user.role === 'customer' && (
                            <li className="navbar-item"><Link to="/book" className="navbar-link">Book Service</Link></li>
                        )}
                        <li className="navbar-item"><Link to="/my-bookings" className="navbar-link">My Bookings</Link></li>
                        <li className="navbar-item"><button onClick={logout} className="navbar-button">Logout</button></li>
                    </>
                ) : (
                    <>
                        <li className="navbar-item"><Link to="/register" className="navbar-link">Register</Link></li>
                        <li className="navbar-item"><Link to="/login" className="navbar-link">Login</Link></li>
                    </>
                )}
            </ul>
        </nav>
    );
};

function App() {
    return (
        <Router>
            <AuthProvider>
                <NotificationProvider>
                    <div className="App">
                        <Navbar />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/login" element={<Login />} />

                            {/* Protected Routes */}
                            <Route path="/technicians" element={
                                <ProtectedRoute allowedRoles={['customer']}>
                                    <TechnicianList />
                                </ProtectedRoute>
                            } />
                            <Route path="/technicians/service/:serviceName" element={
                                <ProtectedRoute allowedRoles={['customer']}>
                                    <TechniciansByService />
                                </ProtectedRoute>
                            } />
                            <Route path="/technicians/:id" element={
                                <ProtectedRoute allowedRoles={['customer']}>
                                    <TechnicianProfile />
                                </ProtectedRoute>
                            } />
                            <Route path="/services" element={
                                <ProtectedRoute allowedRoles={['customer']}>
                                    <ServiceList />
                                </ProtectedRoute>
                            } />
                            <Route path="/book" element={
                                <ProtectedRoute allowedRoles={['customer']}>
                                    <BookingForm />
                                </ProtectedRoute>
                            } />
                            <Route path="/my-bookings" element={
                                <ProtectedRoute allowedRoles={['customer', 'technician']}>
                                    <MyBookings />
                                </ProtectedRoute>
                            } />
                            {/* <Route path="/review" element={<ProtectedRoute allowedRoles={['customer']}><ReviewForm /></ProtectedRoute>} /> */}
                            <Route path="/profile-form" element={
                                <ProtectedRoute allowedRoles={['technician']}>
                                    <TechnicianProfileForm />
                                </ProtectedRoute>
                            } />
                        </Routes>
                    </div>
                </NotificationProvider>
            </AuthProvider>
        </Router>
    );
}

export default App;
